import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, Group } from 'Components/Ant/Radio';

import FormElement from '..';

import './index.css';

class RadioGroup extends Component {
  constructor(props) {
    super(props);

    this.getClassNames = this.getClassNames.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  getClassNames() {
    const { className, isMobile } = this.props;
    return classnames({
      RadioGroup: true,
      [className]: true,
      MobileRadioGroup: isMobile,
    });
  }

  handleChange(e) {
    const { name, onChange } = this.props;
    onChange(name, e.target.value);
  }

  render() {
    const { getClassNames, handleChange } = this;
    const {
      label, name, options, value, disabled,
    } = this.props;
    return (
      <FormElement className={getClassNames()}>
        {label && <div className="label">{label}</div>}
        <Group
          disabled={disabled}
          name={name}
          onChange={handleChange}
          value={value}
        >
          {options.map(({ id, text }) => (
            <Button key={id} value={id}>
              {text}
            </Button>
          ))}
        </Group>
      </FormElement>
    );
  }
}

RadioGroup.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      text: PropTypes.string,
    }),
  ).isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isMobile: PropTypes.bool,
};

RadioGroup.defaultProps = {
  className: '',
  label: '',
  value: '',
  disabled: false,
  isMobile: false,
};

export default RadioGroup;
